const getSelectedOrganisation = () => {
  let selectedOrganisation = localStorage.getItem('selectedOrganisation');
  const orgListArray = getOrganisationsFromAlefUser();
  const hasOrgsInList = orgListArray && orgListArray.length > 0;

  // No organisation is selected yet
  if (selectedOrganisation === null) {
    if (hasOrgsInList) {
      selectedOrganisation = orgListArray[0];
      setSelectedOrganisation(selectedOrganisation);
    }
  }
  // Selected Organisation is different from one in Token
  else if (hasOrgsInList && orgListArray.indexOf(selectedOrganisation) === -1) {
    // eslint-disable-next-line prefer-destructuring
    selectedOrganisation = orgListArray[0];
    setSelectedOrganisation(selectedOrganisation);
  }
  // Selected Organisation exists in localstorage but token has no organisation
  else if (!orgListArray || (orgListArray && orgListArray.length === 0)) {
    selectedOrganisation = null;
    clearSelectedOrganisation();
  }
  return selectedOrganisation;
};

const getOrganisationsFromAlefUser = (): string[] => {
  let organisations;
  try {
    const alefUserObject = JSON.parse(
      localStorage.getItem('alef_ccl_user') || '{}',
    );
    const userObject = alefUserObject.user;

    organisations = userObject.membershipsV2.map(
      (membership: any) => membership.organisation,
    );
  } catch (e) {
    organisations = [];
  }
  return organisations;
};

const setSelectedOrganisation = (organisation: any) => {
  localStorage.setItem('selectedOrganisation', organisation);
};

const clearSelectedOrganisation = () => {
  localStorage.removeItem('selectedOrganisation');
};

export { getSelectedOrganisation, setSelectedOrganisation };
